export default __webpack_public_path__ + "static/media/megaphone.8e9ceebb.svg";